import React, { FC } from "react";
import {
  TableContainer as MuiTableContainer,
  TableContainerProps,
} from "@mui/material";

const TableContainer: FC<TableContainerProps> = (props) => (
  <MuiTableContainer {...props} />
);

export default TableContainer;
